/* Behaviour for the concerns page section. */

const tabs = document.querySelectorAll('.concern-tab');
  const pages = document.querySelectorAll('.concern-page');

  const pageMap = {
    'sleep': 'page-sleep',
    'womens-health': 'page-womens-health',
    'digestion': 'page-digestion',
    'skin': 'page-skin',
    'hair': 'page-hair',
    'stress': 'page-stress',
    'immunity': 'page-immunity'
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      pages.forEach(p => p.classList.remove('active'));

      tab.classList.add('active');
      const pageId = pageMap[tab.dataset.page];
      if (pageId) {
        document.getElementById(pageId).classList.add('active');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  });
